import ConfirmationPopup from 'components/ui/ConfirmationPopup';

/**
 * ConfirmDialog — driven globally by PopupContext.
 * Props: open, title, message, confirmLabel, cancelLabel, onConfirm, onCancel, icon
 */
export default function ConfirmDialog({
  open,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  icon
}) {
  return (
    <ConfirmationPopup
      open={open}
      onClose={onCancel}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      icon={icon}
      maxWidth="xs"
    />
  );
}

